import React, { useState } from 'react';
import { Plus, Minus } from 'react-feather';

/* eslint-disable @typescript-eslint/no-explicit-any */
const Accordion = ({ title, content }: { title: any; content: any }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <div className="d-block">
      <div
        className="border-bottom p-1 mb-1 border-light rounded"
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          cursor: 'pointer',
          background: '#FFFFFF',
        }}
        onClick={() => setIsActive(!isActive)}
      >
        <div className="font-weight-bold">{title}</div>
        <div>{isActive ? <Minus /> : <Plus />}</div>
      </div>
      {isActive ? <div className="p-1">{content}</div> : <></>}
    </div>
  );
};

export default Accordion;
